module.exports = __webpack_public_path__ + "img/house.e0490430.svg";